import React, { useState, useEffect, useRef } from 'react';
import LeaseApiService from '../../services/apiService';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaChevronLeft } from 'react-icons/fa';
import moment from 'moment';
import Select from 'react-select';
import { HashLoader } from 'react-spinners';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import PaymentInvoices from './paymentList';

const AddLeaseAgrementView = () => {
  const apiService = new LeaseApiService();
  const { currencyPrecision } = useCurrency();
  const [activeTab, setActiveTab] = useState(0);
  const [loader, setLoader] = useState(true);
  const [periodFrom, setPeriodFrom] = useState('');
  const [periodTo, setPeriodTo] = useState('');
  const [leaseTerm, setLeaseTerm] = useState('');
  const [gridVisibility, setGridVisibility] = useState([true, false, false, false]);
  const [dataList, setDataList] = useState([]);
  const [additionalCharges, setAdditionalCharges] = useState([]);
  const [InvoiceList, setInvoiceList] = useState([]);
  const [unitRent, setUnitRent] = useState(true);
  const [FilterTab, setFilterTab] = useState(true);
  const [tentantTab, setTanantTab] = useState(false);
  const [tentantJoint, setTanantJoint] = useState(false);
  const location = useLocation();
  const leaseData = location.state;
  const navigate = useNavigate();
  const totalRent = dataList?.reduce((sum, row) => sum + (parseFloat(row?.rentForPeriod) || 0), 0);
  const totalVat = dataList?.reduce((sum, row) => sum + (parseFloat(row?.vat) || 0), 0);
  const rentPerAnum = dataList?.reduce((sum, row) => sum + (parseFloat(row?.rentPerAnum) || 0), 0);
  const totalDiscount = dataList?.reduce((sum, row) => sum + (parseFloat(row?.FreeRent) || 0), 0);
  const calculatedTotal = dataList?.reduce((sum, row) => sum + (parseFloat(row?.total) || 0), 0);
  useEffect(() => {
    getUserList();
  }, [leaseData]);

  const calculateDaysDifference = (from, to) => {
    const fromDate = new Date(from);
    const toDate = new Date(to);

    // Remove time part
    fromDate.setHours(0, 0, 0, 0);
    toDate.setHours(0, 0, 0, 0);

    const diffTime = toDate - fromDate;
    let totalDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    // Calculate year difference
    const yearDiff = toDate.getFullYear() - fromDate.getFullYear();

    // If exactly 1 year range then return 365
    if (yearDiff === 1 && fromDate.getMonth() === toDate.getMonth() && fromDate.getDate() === toDate.getDate()) {
      return 365;
    }

    // If more than 1 year, don't add +1
    if (yearDiff > 1) {
      return yearDiff * 365;
    }

    // Normal ranges less than 1 year
    return totalDays + 1;
  };

  const getUserList = async () => {
    try {
      setLoader(true);
      const params = new URLSearchParams();
      params.append('dropdownTypes', 'LASerPropertyName,LACustomerName,LALeasingAgent,LALeaseRemarks,VatPercentage');
      const customerRes = await apiService.getApiParamater('GET_PROPERT_DROP', `?${params?.toString()}`);
      if (leaseData) {
        const leaseDataParam = new URLSearchParams();
        leaseDataParam.append('Action', 'getLeaseDetailsById');
        leaseDataParam.append('GroupId', leaseData?.groupId);
        const leaseDataRes = await apiService.getApiParamater('GET_UNITNO_DATA', `?${leaseDataParam?.toString()}`);
        let leaseResData = '';
        if (leaseDataRes?.data?.result?.data?.length > 0) {
          let leaseResponse = leaseDataRes?.data?.result?.data[0];
          leaseResData = leaseResponse;
        } else {
          let leaseResponse = leaseDataRes?.data?.result?.data;
          leaseResData = leaseResponse;
        }

        const additionalChargesParam = new URLSearchParams();
        additionalChargesParam.append('Action', 'getLeaseAdditionalDetailsById');
        additionalChargesParam.append('GroupId', leaseData?.groupId);
        const additionalChargesRes = await apiService.getApiParamater('GET_UNITNO_DATA', `?${additionalChargesParam?.toString()}`);
        let AdditionalChargesData = additionalChargesRes?.data?.result?.data;
        if (AdditionalChargesData?.length > 0) {
          const updatedData = AdditionalChargesData.map((item) => ({
            ...item,
            isSelected: true,
          }));
          setAdditionalCharges(updatedData);
        } else if (AdditionalChargesData?.Description) {
          const singleItem = {
            ...AdditionalChargesData,
            isSelected: true,
          };
          setAdditionalCharges([singleItem]);
        }
        // broker = agent
        const selectedAgent = customerRes?.data?.dropdowns?.LALeasingAgent?.find((pro) => pro?.value === leaseResData?.Agent);
        // Leasing Agent = salesperson
        const SalesPerson = customerRes?.data?.dropdowns?.LALeasingAgent?.find((pro) => pro?.value === leaseResData?.SalesPerson);
        const Cust1 = customerRes?.data?.dropdowns?.LACustomerName?.find((pro) => pro?.value === leaseResData?.Cust1_No);
        const Cust2 = customerRes?.data?.dropdowns?.LACustomerName?.find((pro) => pro?.value === leaseResData?.Cust2_No);
        const remarks = customerRes?.data?.dropdowns?.LALeaseRemarks?.find((pro) => pro?.text === leaseResData?.Remarks);
        const taxCode = customerRes?.data?.dropdowns?.VatPercentage?.find((pro) => parseInt(pro?.value) === leaseResData?.Tax_Code);
        // Cust no 1
        const cust1params = new URLSearchParams();
        cust1params.append('Action', 'GetCustomerDetailsByTenantNo');
        cust1params.append('TenantNo', leaseResData?.Cust1_No);
        const cust1res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${cust1params.toString()}`);
        // Cust no 2
        const params = new URLSearchParams();
        params.append('Action', 'GetCustomerDetailsByTenantNo');
        params.append('TenantNo', leaseResData?.Cust2_No);
        const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
        let leaseterm = calculateDaysDifference(leaseResData?.Lease_Date, leaseResData?.Lease_Expiry);
        setTransData({
          ...transData,
          transectionDate: moment(leaseResData?.TransactionDate).format('DD-MMM-YYYY'),
          periodFrom: leaseResData?.Lease_Date,
          periodTo: leaseResData?.Lease_Expiry,
          noInstallment: leaseResData?.PaymentTermNoOfChqs,
          leaseAgent: { label: SalesPerson?.value || '', value: SalesPerson?.text || '' },
          Broker: { label: selectedAgent?.value || '', value: selectedAgent?.text || '' },
          CustomerName: { label: Cust1?.text || '', value: Cust1?.value || '' },
          CustomerAccount: { label: Cust1?.value || '', value: cust1res?.data?.result?.data || '' },
          JointCustomerName: { label: Cust2?.text || '', value: Cust2?.value || '' },
          JointCustomerAccount: { label: Cust2?.value || '', value: res?.data?.result?.data || '' },
          remarks: { label: remarks?.value || '', value: remarks?.text || '' },
          remarks2: remarks?.text,
          arabicRemarks: leaseResData?.RentPI_Remarks,
          leaseTerm: leaseterm,
        });
        setPeriodFrom(moment(leaseResData?.Lease_Date).format('DD-MMM-YYYY'));
        setPeriodTo(moment(leaseResData?.Lease_Expiry).format('DD-MMM-YYYY'));
        setLeaseTerm(leaseterm);
        if (leaseDataRes?.data?.result?.data?.length > 0) {
          const formattedEntry = leaseDataRes?.data?.result?.data?.map((item, index) => ({
            Property: {
              value: item.Property_Id || '', // → property_Id
              label: item.Property_Name || '', // → propertyName
            },
            Unit: {
              value: item.Unit_No || '', // → unitNo
              label: item.Unit_No || '',
            },
            vatRecord: item?.Tax_Code,
            noCommunity: '',
            rentPerAnum: item?.Rent_Per_Annum?.toFixed(currencyPrecision?.decimalNumbers),
            unitClass: item?.UnitClass,
            type: item?.Unit_Type,
            rentForPeriod: item?.Rent?.toFixed(currencyPrecision?.decimalNumbers),
            unitRefNo: item?.UnitRefNo,
            bedRooms: item?.Bedrooms,
            totalArea: item?.Total_Area,
            Landloard: item?.Landlord,
            taxCode: { label: taxCode?.text, value: taxCode?.value },
            category: item?.Unit_Category,
            vat: item?.VAT,
            FreeRent: item?.Discount?.toFixed(currencyPrecision?.decimalNumbers),
            discount: item?.Discount?.toFixed(currencyPrecision?.decimalNumbers),
            total: item?.Total?.toFixed(currencyPrecision?.decimalNumbers),
            parkingNo: item?.ParkingNo,
            munAcNo: item?.MuncAcNo,
            MunicipalityNo: item?.MunicipalityNo,
            Parking: item?.Parking,
            taxRate: item?.TaxPercent || 0,
            discountPerc: item?.DiscountPercent || 0,
            discount: item?.Discount?.toFixed(currencyPrecision?.decimalNumbers) || 0,
            vatRecord: item?.TaxCode,
          }));
          setDataList(formattedEntry);
        } else {
          const formattedEntry = {
            Property: {
              value: leaseResData.Property_Id || '', // → property_Id
              label: leaseResData.Property_Name || '', // → propertyName
            },
            Unit: {
              value: leaseResData.Unit_No || '', // → unitNo
              label: leaseResData.Unit_No || '',
            },
            vatRecord: leaseResData?.Tax_Code,
            noCommunity: '',
            rentPerAnum: leaseResData?.Rent_Per_Annum?.toFixed(currencyPrecision?.decimalNumbers),
            unitClass: leaseResData?.UnitClass,
            type: leaseResData?.Unit_Type,
            rentForPeriod: leaseResData?.Rent?.toFixed(currencyPrecision?.decimalNumbers),
            unitRefNo: leaseResData?.UnitRefNo,
            bedRooms: leaseResData?.Bedrooms,
            totalArea: leaseResData?.Total_Area,
            Landloard: leaseResData?.Landlord,
            taxCode: { label: taxCode?.text, value: taxCode?.value },
            category: leaseResData?.Unit_Category,
            vat: leaseResData?.VAT,
            FreeRent: leaseResData?.Discount?.toFixed(currencyPrecision?.decimalNumbers),
            discount: leaseResData?.Discount?.toFixed(currencyPrecision?.decimalNumbers),
            total: leaseResData?.Total?.toFixed(currencyPrecision?.decimalNumbers),
            parkingNo: leaseResData?.ParkingNo,
            munAcNo: leaseResData?.MuncAcNo,
            MunicipalityNo: leaseResData?.MunicipalityNo,
            Parking: leaseResData?.Parking,
            taxRate: leaseResData?.TaxPercent || 0,
            discountPerc: leaseResData?.DiscountPercent || 0,
            discount: leaseResData?.Discount?.toFixed(currencyPrecision?.decimalNumbers) || 0,
            vatRecord: leaseResData?.TaxCode,
          };
          setDataList([formattedEntry]);
        }
        handlePaymentPlan(leaseData);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.error('Error fetching data:', error?.customerRes?.data?.message);
    }
  };
  const [formData, setFormData] = useState({
    vatRecord: '',
    Property: [],
    Unit: [],
    noCommunity: '',
    rentPerAnum: '',
    unitClass: '',
    type: '',
    rentForPeriod: '',
    unitRefNo: '',
    bedRooms: '',
    FreeRent: '',
    discountPerc: '',
    totalArea: '',
    Landloard: '',
    taxCode: [],
    category: '',
    vat: '',
    discount: '',
    total: '',
    parkingNo: '',
    munAcNo: '',
    Parking: '',
    taxRate: '',
  });
  const [transData, setTransData] = useState({
    transectionDate: '',
    periodFrom: '',
    periodTo: '',
    noInstallment: '',
    CustomerName: '',
    CustomerAccount: '',
    leaseAgent: '',
    JointCustomerName: '',
    JointCustomerAccount: '',
    Broker: '',
    remarks: '',
    remarks2: '',
    arabicRemarks: '',
  });
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
    setGridVisibility(newGridVisibility);
  };
  const colDefs = [
    {
      width: 50,
      checkboxSelection: true,
      headerCheckboxSelection: true,
      suppressMovable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: 'center' },
    },
    { headerName: 'Description', field: 'Description', filter: true, floatingfilter: true, suppressMovable: true, width: 200, editable: true },
    { headerName: 'Amount', field: 'Amount', suppressMovable: true, width: 150, editable: true },
    { headerName: 'Vat Amount', field: 'VAT', filter: true, floatingfilter: true, suppressMovable: true, width: 150 },
    {
      headerName: 'Vat Description',
      field: 'VATDescription',
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 150,
      editable: true,
      cellEditor: 'agSelectCellEditor',
    },
    { headerName: 'Total', field: 'Total', filter: true, floatingfilter: true, suppressMovable: true, width: 150 },
    {
      headerName: 'Posting',
      field: 'Posting',
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 150,
      editable: true,
      cellRenderer: 'agCheckboxCellRenderer',
      cellEditor: 'agCheckboxCellEditor',
      cellStyle: { textAlign: 'center' },
    },
    { headerName: 'Cradit Account', field: 'CrAcCode', filter: true, floatingfilter: true, suppressMovable: true, width: 200, editable: true },
    { headerName: 'Remarks', field: 'Remarks', filter: true, editable: true, floatingfilter: true, suppressMovable: true, width: 200 },
    {
      headerName: 'Deposit',
      field: 'IsDeposit',
      filter: true,
      floatingfilter: true,
      suppressMovable: true,
      width: 200,
      editable: true,
      cellRenderer: 'agCheckboxCellRenderer',
      cellEditor: 'agCheckboxCellEditor',
      cellStyle: { textAlign: 'center' },
    },
    { headerName: 'Actions', width: 100, suppressMovable: true, cellClass: 'actions-cell' },
  ];

  const handlePaymentPlan = async (rowData) => {
    const params = new URLSearchParams();
    params.append('Action', 'GetPaymentSchedule');
    params.append('LeaseNo', rowData?.leaseNo);
    const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params?.toString()}`);
    const planData = res?.data?.result?.data;
    setInvoiceList(planData == null ? [] : planData);
  };
  return (
    <div className="p-3">
      <div className="d-flex mb-3">
        <div className="col-lg-8 nav nav-pills overslid d-flex gap-4">
          <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`} onClick={() => handleTabClick(0)}>
            Transaction and Tenant
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`} onClick={() => handleTabClick(1)}>
            Unit Details
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`} onClick={() => handleTabClick(2)}>
            Additional Charges
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 3 ? 'sideActive' : ''}`} onClick={() => handleTabClick(3)}>
            Payment Plan
          </div>
        </div>
        <div className="col-lg-4 end d-flex gap-1">
          <div className="mainbtnSecondary flex-end gap-2 w-50" onClick={() => navigate('/Property/Management/LeaseAgreement')}>
            <FaChevronLeft color="#fff" className="center mt-1 mx-2" />
            <div className="center">Back</div>
          </div>
        </div>
      </div>
      {gridVisibility[0] && (
        <div className="">
          <div className="cost-center-section mt-3">
            <div className="d-flex cursor-pointer slide-header" onClick={() => setFilterTab(!FilterTab)}>
              <div className="h6 pt-1">Transaction Details</div>
            </div>
            <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
              <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                {loader === true ? (
                  <div className="center p-5">
                    <HashLoader color="#6e5199" />
                  </div>
                ) : (
                  <div className="form-group grid-contain ">
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Transaction Date
                      </label>
                      <input
                        type="text"
                        className="p-2 form-control w-75"
                        disabled
                        name="transectionDate"
                        value={moment(transData?.transectionDate).format('DD-MMM-YYYY')}
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="periodFrom" className="form-label pt-1 start">
                        Period From
                      </label>
                      <input type="text" className="p-2 form-control w-75" disabled name="periodfrom" value={moment(periodFrom).format('DD-MMM-YYYY')} />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="periodTo" className="form-label pt-1 start">
                        Period To
                      </label>
                      <input type="text" className="p-2 form-control w-75" disabled value={moment(periodTo).format('DD-MMM-YYYY')} />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="leaseTerm" className="form-label pt-1 start">
                        Lease Term
                      </label>
                      <input type="text" className="p-2 form-control w-75" disabled name="leaseTerm" value={leaseTerm} readOnly />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        No. Of Installments
                      </label>
                      <input type="number" className="p-2 form-control w-75" disabled value={transData?.noInstallment} />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Select Remarks
                      </label>
                      <Select
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 5,
                          padding: 9,
                        })}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                            color: state.isFocused ? '#000 ' : '#000',
                            ':hover': {
                              backgroundColor: '#F5F5F5',
                              color: '#000 ',
                            },
                          }),
                        }}
                        className="w-75 p-0"
                        isDisabled
                        value={transData.remarks}
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Remarks
                      </label>
                      <input type="text" className="p-2 form-control w-75" disabled name="remarks2" value={transData?.remarks2} />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Arabic Remarks
                      </label>
                      <input type="text" className="p-2 form-control w-75" disabled name="arabicRemarks" value={transData?.arabicRemarks} />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="cost-center-section mt-3">
            <div className="d-flex cursor-pointer slide-header" onClick={() => setTanantTab(!tentantTab)}>
              <div className="h6 pt-1">Tenant Primary Details</div>
            </div>
            <div className={`slide-content ${tentantTab ? 'open' : 'closed'}`}>
              <div className={`border-box2 p-3 ${tentantTab ? 'slide-in' : 'slide-out'}`}>
                {loader === true ? (
                  <div className="center p-5">
                    <HashLoader color="#6e5199" />
                  </div>
                ) : (
                  <div className="form-group grid-contain ">
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Name
                      </label>
                      <Select
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 5,
                          padding: 9,
                        })}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                            color: state.isFocused ? '#000 ' : '#000',
                            ':hover': {
                              backgroundColor: '#F5F5F5',
                              color: '#000 ',
                            },
                          }),
                        }}
                        className="w-75 p-0"
                        isDisabled
                        readOnly
                        value={transData.CustomerName}
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Acc/ Code
                      </label>
                      <Select
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 5,
                          padding: 9,
                        })}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                            color: state.isFocused ? '#000 ' : '#000',
                            ':hover': {
                              backgroundColor: '#F5F5F5',
                              color: '#000 ',
                            },
                          }),
                        }}
                        className="w-75 p-0"
                        isDisabled
                        readOnly
                        value={transData.CustomerAccount}
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Contact No.
                      </label>
                      <input
                        type="text"
                        className="p-2 form-control w-75"
                        disabled
                        name="periodto"
                        value={transData?.CustomerAccount?.value?.ContactNo}
                        readOnly
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Email
                      </label>
                      <input
                        type="email"
                        className="p-2 form-control w-75"
                        disabled
                        name="leaseTerm"
                        value={transData?.CustomerAccount?.value?.Email}
                        readOnly
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Passport / ID
                      </label>
                      <input
                        type="text"
                        className="p-2 form-control w-75"
                        disabled
                        name="installments"
                        value={transData?.CustomerAccount?.value?.IDNo}
                        readOnly
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Nationality
                      </label>
                      <input
                        type="text"
                        className="p-2 form-control w-75"
                        disabled
                        name="remarks"
                        value={transData?.CustomerAccount?.value?.Nationality}
                        readOnly
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Vat Reg No
                      </label>
                      <input
                        type="text"
                        className="p-2 form-control w-75"
                        disabled
                        name="remarks"
                        value={transData?.CustomerAccount?.value?.VATRegNo}
                        readOnly
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Leasing Agent
                      </label>
                      <Select
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 5,
                          padding: 9,
                        })}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                            color: state.isFocused ? '#000 ' : '#000',
                            ':hover': {
                              backgroundColor: '#F5F5F5',
                              color: '#000 ',
                            },
                          }),
                        }}
                        className="w-75 p-0"
                        isDisabled
                        readOnly
                        value={transData.leaseAgent}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="cost-center-section my-3">
            <div className="d-flex cursor-pointer slide-header" onClick={() => setTanantJoint(!tentantJoint)}>
              <div className="h6 pt-1">Tenant Joint Details</div>
            </div>
            <div className={`slide-content ${tentantJoint ? 'open' : 'closed'}`}>
              <div className={`border-box2 p-3 ${tentantJoint ? 'slide-in' : 'slide-out'}`}>
                {loader === true ? (
                  <div className="center p-5">
                    <HashLoader color="#6e5199" />
                  </div>
                ) : (
                  <div className="form-group grid-contain ">
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Name
                      </label>
                      <Select
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 5,
                          padding: 9,
                        })}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                            color: state.isFocused ? '#000 ' : '#000',
                            ':hover': {
                              backgroundColor: '#F5F5F5',
                              color: '#000 ',
                            },
                          }),
                        }}
                        className="w-75 p-0"
                        isDisabled
                        readOnly
                        value={transData.JointCustomerName}
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Acc/ Code
                      </label>
                      <Select
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 5,
                          padding: 9,
                        })}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                            color: state.isFocused ? '#000 ' : '#000',
                            ':hover': {
                              backgroundColor: '#F5F5F5',
                              color: '#000 ',
                            },
                          }),
                        }}
                        className="w-75 p-0"
                        isDisabled
                        readOnly
                        value={transData.JointCustomerAccount}
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Contact No.
                      </label>
                      <input
                        type="text"
                        className="p-2 form-control w-75"
                        disabled
                        name="periodto"
                        value={transData?.JointCustomerAccount?.value?.ContactNo}
                        readOnly
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Email
                      </label>
                      <input
                        type="email"
                        className="p-2 form-control w-75"
                        disabled
                        name="leaseTerm"
                        value={transData?.JointCustomerAccount?.value?.Email}
                        readOnly
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Passport / ID
                      </label>
                      <input
                        type="text"
                        className="p-2 form-control w-75"
                        disabled
                        name="installments"
                        readOnly
                        value={transData?.JointCustomerAccount?.value?.IDNo}
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Nationality
                      </label>
                      <input
                        type="text"
                        className="p-2 form-control w-75"
                        disabled
                        name="remarks"
                        value={transData?.JointCustomerAccount?.value?.Nationality}
                        readOnly
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Vat Reg No
                      </label>
                      <input
                        type="text"
                        className="p-2 form-control w-75"
                        disabled
                        name="remarks"
                        value={transData?.JointCustomerAccount?.value?.VATRegNo}
                        readOnly
                      />
                    </div>
                    <div className="d-flex">
                      <label htmlFor="validationCustom01" className="form-label pt-1 start">
                        Broker
                      </label>
                      <Select
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 5,
                          padding: 9,
                        })}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          option: (provided, state) => ({
                            ...provided,
                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                            color: state.isFocused ? '#000 ' : '#000',
                            ':hover': {
                              backgroundColor: '#F5F5F5',
                              color: '#000 ',
                            },
                          }),
                        }}
                        className="w-75 p-0"
                        isDisabled
                        readOnly
                        value={transData.Broker}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {gridVisibility[1] && (
        <>
          <div className="cost-center-section my-3">
            <div className="d-flex cursor-pointer slide-header" onClick={() => setUnitRent(!unitRent)}>
              <div className="h6 pt-1">Unit Rent Details</div>
            </div>
            <div className={`slide-content ${unitRent ? 'open' : 'closed'}`}>
              <div className={`border-box2 p-3 ${unitRent ? 'slide-in' : 'slide-out'}`}>
                <div className="form-group grid-contain ">
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Property
                    </label>
                    <Select
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 5,
                        padding: 9,
                      })}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      className="w-75 p-0"
                      isDisabled
                      readOnly
                      value={formData.Property}
                    />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Unit *
                    </label>
                    <Select
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 5,
                        padding: 9,
                      })}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      className="w-75 p-0"
                      isDisabled
                      readOnly
                      value={formData.Unit}
                    />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Munc No.community{' '}
                    </label>
                    <input type="text" className="p-2 form-control w-75" disabled name="noCommunity" value={formData.noCommunity} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Rent Per Anum
                    </label>
                    <input type="email" className="p-2 form-control w-75" disabled name="rentPerAnum" value={formData.rentPerAnum} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Unit Class
                    </label>
                    <input type="text" className="p-2 form-control w-75" disabled name="unitClass" value={formData.unitClass} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Type
                    </label>
                    <input type="text" className="p-2 form-control w-75" disabled name="type" value={formData.type} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Rent For period
                    </label>
                    <input type="text" className="p-2 form-control w-75" disabled name="rentForPeriod" value={formData.rentForPeriod} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Unit Ref No.
                    </label>
                    <input type="text" className="p-2 form-control w-75" disabled name="unitRefNo" value={formData.unitRefNo} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Bed Room’s
                    </label>
                    <input type="text" className="p-2 form-control w-75" disabled name="bedRooms" value={formData.bedRooms} readOnly />
                  </div>
                  <div className="d-flex gap-2">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Free Rent
                    </label>
                    <input type="number" className="p-2 form-control w-25" name="discountPerc" placeholder="%" value={formData.discountPerc} readOnly />
                    <input type="number" className="p-2 form-control w-50" name="FreeRent" placeholder="0.00" value={formData.FreeRent} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Landlord
                    </label>
                    <input type="text" className="p-2 form-control w-75" disabled name="Landloard" value={formData.Landloard} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Category
                    </label>
                    <input type="text" className="p-2 form-control w-75" disabled name="category" value={formData.category} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Tax Code *
                    </label>
                    <Select
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 5,
                        padding: 9,
                      })}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      className="w-75 p-0"
                      isDisabled
                      readOnly
                      value={formData.taxCode}
                    />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Total Area
                    </label>
                    <input type="text" className="p-2 form-control w-75" disabled name="totalArea" value={formData.totalArea} readOnly />
                  </div>
                  <div className="d-flex gap-4 center">
                    <input className="form-check-input" type="checkbox" id="rentCheck" style={{ width: '20px', height: '20px' }} name="rentCheck" />
                    <label className="text-danger">Rent-Non Leasing</label>
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      VAT
                    </label>
                    <input type="text" className="p-2 form-control w-75" disabled name="vat" value={formData.vat} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Munc / Ac No.{' '}
                    </label>
                    <input type="number" className="p-2 form-control w-75" disabled name="munAcNo" value={formData.munAcNo} readOnly />
                  </div>
                  <div className="d-flex center">
                    <h6 className="text-danger text-bold">Unit Rent</h6>
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Total
                    </label>
                    <input type="number" className="p-2 form-control w-75" disabled name="total" value={formData.total} readOnly />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="table-container my-3" style={{ overflowX: 'auto', height: '400px' }}>
              <table>
                <thead className="dynoTable">
                  <tr>
                    <th>Action</th>
                    <th>Property</th>
                    <th>Unit No.</th>
                    <th>Unit Ref No.</th>
                    <th>Unit Class</th>
                    <th>Area</th>
                    <th>Discount</th>
                    <th>Tax</th>
                    <th>Rent</th>
                    <th>VAT</th>
                    <th>Total</th>
                    <th>Rent Per Anum</th>
                    <th>Bed Room’s</th>
                    <th>Unit Type</th>
                    <th>Unit Category</th>
                    <th>Parking No</th>
                    <th>Munc A/c No.</th>
                    <th>Munc No. Community</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(dataList) &&
                    dataList?.map((data, index) => (
                      <tr key={index}>
                        <td className="m-0 p-0">
                          <input className="p-1" type="checkbox" style={{ width: '80px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.Property?.label || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.Unit.label || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.unitRefNo || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.unitClass || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input
                            className="p-1"
                            value={Number(data.totalArea)?.toFixed(currencyPrecision?.decimalNumbers) || ''}
                            disabled
                            style={{ width: '130px' }}
                          />
                        </td>
                        <td className="m-0 p-0">
                          <input
                            className="p-1"
                            value={Number(data.FreeRent)?.toFixed(currencyPrecision?.decimalNumbers) || ''}
                            disabled
                            style={{ width: '130px' }}
                          />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.taxCode?.label || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input
                            className="p-1"
                            value={Number(data.rentForPeriod)?.toFixed(currencyPrecision?.decimalNumbers) || ''}
                            disabled
                            style={{ width: '130px' }}
                          />
                        </td>
                        <td className="m-0 p-0">
                          <input
                            className="p-1"
                            value={Number(data.vat)?.toFixed(currencyPrecision?.decimalNumbers) || 0}
                            disabled
                            style={{ width: '130px' }}
                          />
                        </td>
                        <td className="m-0 p-0">
                          <input
                            className="p-1"
                            value={Number(data.total)?.toFixed(currencyPrecision?.decimalNumbers) || ''}
                            disabled
                            style={{ width: '130px' }}
                          />
                        </td>
                        <td className="m-0 p-0">
                          <input
                            className="p-1"
                            value={Number(data.rentPerAnum)?.toFixed(currencyPrecision?.decimalNumbers)}
                            disabled
                            style={{ width: '130px' }}
                          />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.bedRooms || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.type || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.category || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.parkingNo || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.munAcNo || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.noCommunity || ''} disabled />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between boxs">
              <div className="d-flex gap-2">
                <div className="totalhead center">Total Units</div>
                <div className="field">{dataList?.length || '---'}</div>
              </div>
              <div className="d-flex gap-2">
                <div className="totalhead center">Discount</div>
                <div className="field">{`${totalDiscount}` || '---'}</div>
              </div>
              <div className="d-flex gap-2">
                <div className="totalhead center">Vat Total</div>
                <div className="field">{totalVat || '---'}</div>
              </div>
              <div className="d-flex gap-2">
                <div className="totalhead center">Rent Total</div>
                <div className="field">{totalRent || '---'}</div>
              </div>
              <div className="d-flex gap-2">
                <div className="totalhead center">Total Amount</div>
                <div className="field">{calculatedTotal || '---'}</div>
              </div>
              <div className="d-flex gap-2">
                <div className="totalhead center">Rent Per Anum Total</div>
                <div className="field">{rentPerAnum || '---'}</div>
              </div>
            </div>
          </div>
        </>
      )}
      {gridVisibility[2] && (
        <div className="ag-theme-quartz" style={{ height: 500, suppressMovable: true, width: '100%' }}>
          <AgGridReact
            getRowStyle={(params) => {
              if (params.node.rowIndex % 2 === 0) {
                return { background: '#F0EDF5' };
              } else {
                return { background: '#fff' };
              }
            }}
            rowData={additionalCharges}
            enableFilter={true}
            floatingFilter={true}
            columnDefs={colDefs}
          />
        </div>
      )}
      {gridVisibility[3] && <PaymentInvoices InvoiceList={InvoiceList} />}
    </div>
  );
};

export default AddLeaseAgrementView;
